import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import React from 'react';

export interface UploadErrorProps {
  message: string;
  onDismiss: () => void;
}

export function UploadError({ message, onDismiss }: UploadErrorProps) {
  return (
    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
      <strong className="font-bold">Error: </strong>
      <span className="block sm:inline">{message}</span>
      <span className="absolute top-0 bottom-0 right-0 px-4 py-3">

        <FontAwesomeIcon icon={faClose} size="1x" onClick={onDismiss} className=' cursor-pointer' />

      </span>
    </div>
  );
}